// PusherContext.js
import { createContext, useContext } from 'react';

// Création du contexte Pusher
const PusherContext = createContext(null);

// Hook pour utiliser le contexte Pusher
export const usePusher = () => useContext(PusherContext);

export default PusherContext;
